import React from 'react';
import { EntityValidationWarning } from './EntityValidationWarning';
import { EntityAssignment } from '../../types/workflow';

interface SageReadinessWarningProps {
  /** The entity assignment to check for Sage readiness */
  entity: EntityAssignment | null | undefined;
  /** The role label (e.g. "Client", "Lab") shown in the warning message */
  role: string;
  /** Optional callback to fix the issue — shows "Fix" button when provided */
  onFix?: () => void;
  /** Whether the fix action is loading */
  fixLoading?: boolean;
}

/**
 * SageReadinessWarning Component
 *
 * Thin wrapper around EntityValidationWarning with variant="sage-readiness".
 * Maintains backward compatibility for existing callers.
 */
export const SageReadinessWarning: React.FC<SageReadinessWarningProps> = (props) => (
  <EntityValidationWarning {...props} variant="sage-readiness" />
);

export default SageReadinessWarning;
